module.exports = __webpack_public_path__ + "img/M.1b8749e8.webp";